<mat-toolbar class="secondary-toolbar mat-elevation-z1">
  <ng-container *ngIf="selectedAssessment">
    <div *ngIf="state!='LIST' && allowList" class="secondary-toolbar-item selectable" (click)="showList()"><mat-icon>list</mat-icon>All Certifications</div>
    <div class="secondary-toolbar-item"><mat-icon *ngIf="allowList" svgIcon="cw:action_next"></mat-icon>{{selectedAssessment.assessmentName}} {{selectedAssessment.updatedAt | date:'short'}}</div>
  </ng-container>
</mat-toolbar>

<section class="main-content">
  <app-certification-reviewer  *ngIf="state=='LIST'" (stateChange)="onStateChange($event)" #assessmentList></app-certification-reviewer>
  <cw-ci-assessment-report *ngIf="state=='ASSESSMENT_REPORT'" (stateChange)="onStateChange($event)" [account]='account' [accountAssessment]='selectedAssessment'></cw-ci-assessment-report>
  <div *ngIf="selectedAssessment?.status == 'IN_PROGRESS'">This certification assessment is currently in progress with partner</div>
</section>
